<template>
  <b-container>
    <b-row align-h="end">
      <b-col cols="auto">
        <b-button
          variant="outline-primary"
          @click="addShortContentToType(type)">
          Add Short Content
        </b-button>&nbsp;
        <b-button
          variant="outline-primary"
          @click="addApplicationPromoToType(type)">
          Add App Item
        </b-button>
      </b-col>
    </b-row>
    <draggable
      v-model="insiderOrder"
      tag="ul"
      class="list-group mt-3"
      handle=".drag-title">
      <li
        v-for="(element, index) in insiderOrdered"
        v-show="showRow(element)"
        :key="element.id"
        class="list-group-item">
        <div>
          <div class="drag-title">
            <span
              v-b-toggle="'collapse-'+index"
              class="pointer">
              <i :class="['fa', iconForElement(element)]" />
              {{ element.title }}
            </span>
            <i
              class="fa fa-times close"
              @click="confirmRemoval({ id: element.title }, () => removeItemFromTypeById({ id: element.id, type }))" />
          </div>
          <b-collapse :id="'collapse-'+index">
            <component
              :is="getComponentNameForElement(element)"
              :cloudinary="true"
              :constraint="insiderImageConstraint"
              v-bind="element"
              is-insider
              class="mt-3"
              @field-update="onComponentFieldUpdate" />
          </b-collapse>
        </div>
      </li>
    </draggable>
  </b-container>
</template>

<script>
import draggable from 'vuedraggable'
import { mapMutations, mapGetters } from 'vuex'
import ApplicationPromo from '@/components/ApplicationPromo'
import ShortContent from '@/components/ShortContent'
import { mapFields } from 'vuex-map-fields'
import ConfirmRemoval from '@/mixins/ConfirmRemoval'
import imageconstraints from "@/services/imageconstraints"

export default {
  name: 'TeamMashupInsider',
  components: {
    draggable,
    ShortContent,
    ApplicationPromo,
  },
  mixins: [ConfirmRemoval],
  data: () => ({
    insiderImageConstraint: imageconstraints.MashupInsider,
  }),
  computed: {
    ...mapGetters(['insider', 'insiderOrdered']),
    ...mapFields([
      'teamId',
      'locale',
      'platform',
      'device',
    ]),
    insiderOrder: {
      get() {
        return this.$store.state.mashup.insiderOrder
      },
      set(order) {
        const type = this.type

        this.updateTypeOrder({ order, type })
      },
    },
    type() {
      return 'insider'
    },
  },
  methods: {
    ...mapMutations([
      'addShortContentToType',
      'addApplicationPromoToType',
      'removeItemFromTypeById',
      'updateTypeOrder',
      'updateTypeField',
    ]),
    iconForElement(element = {}) {
      return {
        'short-content': 'fa-edit',
        'application-promo': 'fa-link',
      }[element.type] || 'fa-question'
    },
    getComponentNameForElement(element = {}) {
      return {
        'short-content': 'ShortContent',
        'application-promo': 'ApplicationPromo',
      }[element.type]
    },
    onAssetSelect() {
      this.$refs.assetUploadModal.hide()
    },
    onComponentFieldUpdate(data) {
      const type = this.type

      this.updateTypeField({
        id: data.id,
        node: data.field,
        value: data.value,
        type,
      })
    },
    showRow(element) {
      const { locale } = this
      const self = this

      if (locale !== element.locale) {
        return false
      }

      return ['platform', 'device'].every((key) => element[`${key}s`].includes(self[key]) || self[key] === "unfiltered")
    },
  },
}
</script>
